type DictaphoneMatchSignatureParams = {
  deviceLabel: string;
  matchingProductIds: ReadonlyArray<string>;
  selectedProductId: string | undefined;
};

export const createDictaphoneMatchSignature = ({
  deviceLabel,
  matchingProductIds,
  selectedProductId,
}: DictaphoneMatchSignatureParams): string =>
  JSON.stringify({
    deviceLabel,
    matchingProductIds,
    selectedProductId,
  });
